<template>
    <div>
        <a-button @click="on_verify">实名认证</a-button>

                <a-button @click="on_verify_status">检查认证状态</a-button>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                form_verify: {
                    name: "上海分型网络科技有限公司",
                },
            };
        },
        methods: {
            on_verify() {
                this.$http
                    .post("settings/contract/verify", this.form_verify)
                    .then((res) => {
                        if (res.success) {
                            this.$success({
                                title: "请求成功，请将该链接地址发给客户进行实名认证",
                                centered: true,
                                content: res.data.url,
                            });

                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        // this.submitting = false;
                    });
            },
            on_verify_status() {
                this.$http
                    .post("settings/contract/verify_status")
                    .then((res) => {
                        if (res.success) {
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        // this.submitting = false;
                    });
            },
        },
    };
</script>
